import * as React from 'react';
import TradePage from '../../../common/components/TradePage/TradePage';
import GTPFlowPageSubtitle from '../GTPFlowPageSubtitle/GTPFlowPageSubtitle';
import config from '../../../store/mmd/config';
import { ILoanBalanceUIProps } from './LoanBalanceInterfaces';
import { ButtonText, validationMessages } from '../constants';

const LOAN_BALANCE_OPTIONS = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
];

export const LoanBalanceUI: React.FC<ILoanBalanceUIProps> = (props) => {
    const {
        pageTitle,
        pageSubTitle,
        stepperRoutes,
        goToRoute,
        dispatchAnalytics,
        renderDisclaimer,
        hasOpenLoan,
        vehicleName,
        goBack,
        hasUniqueEstimateOption,
        removeTrade,
        tradeIndex,
        urlPath
    } = props;

    const [validationError, setValidationError] = React.useState<string>('');

    React.useEffect(() => {
        setValidationError('');
    }, [hasOpenLoan]);

    const handleLoanStatusChange = (value: boolean) => {
        props.onLoanStatusChange(value);
        setValidationError('');
    };

    const validateAndProceed = () => {
        const { hasOpenLoan } = props;

        if (hasOpenLoan === null) {
            setValidationError(validationMessages.selectLoanStatus);
            return;
        }

        props.next(hasOpenLoan);
    };

    const getNextButtonText = () => {
        if (hasOpenLoan === false) {
            return ButtonText.ContinueToSummary;
        }
        return ButtonText.Continue;
    };

    return (
        <TradePage
            headerOnTop
            showCustomTitle
            pageClass="loan-balance-page"
            pageTitle={pageTitle}
            pageSubTitle={<GTPFlowPageSubtitle pageSubtitle={pageSubTitle} suffix={vehicleName} tradeIndex={tradeIndex} />}
            renderDisclaimer={renderDisclaimer}
            goToRoute={goToRoute}
            dispatchAnalytics={dispatchAnalytics}
            footerProps={{
                onActionButtonClick: validateAndProceed,
                showBackButton: true,
                buttonText: getNextButtonText(),
                onBackButtonClick: () => goBack(hasUniqueEstimateOption, props.tradeInSource),
                disableActionButton: hasOpenLoan === null ? true : false,
                fullWidthLayout: true,
                showSkipButton: true,
                skipButtonText: 'Cancel Trade-in',
                onSkipButtonClick: removeTrade
            }}
            stepperRoutes={stepperRoutes}
            showTradeErrorMessage={false}
            staticAssetsConfig={config.staticImages}
            stepLabelVisible={true}
            isStepperClickable={false}
            urlPath={urlPath}
        >
            <div className="loan-balance-container">
                <div className="loan-balance-form">
                    <div className="loan-question">
                        <h5>Do you have an open loan balance on your trade-in?</h5>
                    </div>

                    <div className="loan-options">
                        {LOAN_BALANCE_OPTIONS.map((option) => (
                            <div key={option.label} className="loan-option">
                                <label className="radio-option">
                                    <input
                                        type="radio"
                                        name="hasOpenLoan"
                                        value={option.value.toString()}
                                        checked={hasOpenLoan === option.value}
                                        onChange={() => handleLoanStatusChange(option.value)}
                                    />
                                    <span className="radio-checkmark"></span>
                                    <span className="radio-label">{option.label}</span>
                                </label>
                            </div>
                        ))}
                    </div>

                    {validationError && (
                        <div className="validation-error">
                            <span className="error-message">{validationError}</span>
                        </div>
                    )}
                </div>
            </div>
        </TradePage>
    );
};

export default LoanBalanceUI;
